import { useEffect, useState } from 'react';
import { attendanceHttp } from '@utils';

function useAttendOptions(requestUrl) {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [originData, setOriginData] = useState([]);

  const getOptions = async () => {
    try {
      setLoading(true);
      const res = await attendanceHttp.get(requestUrl);
      if (res.code === 0) {
        const { data } = res;
        setOptions(data);
        setOriginData(data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (requestUrl) {
      getOptions();
    } else {
      setOptions([]);
      setOriginData([]);
    }
  }, [requestUrl]);

  return { loading, options, originData };
}

export default useAttendOptions;
